<template>
  <i class="app-icon mdi" :class="icon" :style="iconStyle" aria-hidden="true"></i>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    icon: string
    size?: number | string
    color?: string
  }>(),
  {
    size: 24,
  },
)

const iconStyle = computed(() => ({
  fontSize: typeof props.size === 'number' ? `${props.size}px` : props.size,
  color: props.color,
  lineHeight: 1,
}))
</script>

<style lang="scss" src="./AppIcon.scss"></style>
